export default __webpack_public_path__ + "static/media/exterior6.67a62416.jpg";